import { AxiosError, AxiosResponse } from "axios";
import { useQuery } from "@tanstack/react-query";

import { axiosInstanceNamek } from "@/service/Axios";

import { IMaterial } from "../models/materials.types";

import { MATERIALS_KEYS as KEYS } from "./queryKeys";

export const getMaterialById = async (id: number) => {
  return axiosInstanceNamek
    .get<void, AxiosResponse<IMaterial>>(`v1/materials/${id}`)
    .then((response) => response.data);
};

export function useGetMaterialById(id: number) {
  return useQuery<IMaterial, AxiosError>({
    queryFn: () => getMaterialById(id),
    queryKey: [KEYS.RECORDS, KEYS.BY_ID, id],
    enabled: !!id,
    retry: 0,
  });
}
